module.exports = __webpack_public_path__ + "static/media/w (23).d73efb01.jpg";